const VALUE_INDEX = 1
const COOKIE_SEPARATOR = ';'
const KEY_VALUE_SEPARATOR = '='
/**
 * Retrieves the value of a cookie by its name from the document's cookies
 * @param {string} name - The name or key of the cookie to retrieve
 * @returns {string|null} The decoded value of the cookie if found, null otherwise
 * @example
 * // Get value of 'userToken' cookie from document.cookie
 * const userToken = getCookie('userToken')
 */
const getCookie = (name: string): string | null => {
  if (!document.cookie) {
    return null
  }

  const cookies = document.cookie.split(COOKIE_SEPARATOR)
  const cookieName = `${name}=`
  const theMatchingCookie = (cookie: string) =>
    cookie.trim().startsWith(cookieName)
  const match = cookies.find(theMatchingCookie)
  const matchValue = (rawMatch) =>
    decodeURIComponent(rawMatch.split(KEY_VALUE_SEPARATOR)[VALUE_INDEX])

  return match ? matchValue(match) : null
}

export default getCookie
